import { FaFilter } from "react-icons/fa";
import ExpenseCard from "./ExpenseCard";
import styled from "styled-components";
import { Utils } from "../../utils";
import { MdPayment } from "react-icons/md";

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 1rem;
`;

const Title = styled.div`
  font-weight: 700;
  color: #000000;
  font-size: 1.1rem;

  span {
    color: #28a745;
    margin-left: 0.3rem;
  }
`;

const Subtitle = styled.div`
  color: #222;
  font-size: 1rem;
  margin-top: 0.2rem;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-weight: 600;

  span {
    color: #28a745;
    margin-left: 0.3rem;
  }
`;

const ButtonGroup = styled.div<{ solid?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 6rem;

  button {
    border: 1px solid #28a745;
    background: ${(props) => (props.solid ? "#28a745" : "#ffffff")};
    color: ${(props) => (props.solid ? "#fff" : "#28a745")};
    padding: 0.4rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;

    &:first-child {
      border-color: #28a745;
      color: ${(props) => (props.solid ? "white" : "#28a745")};
    }
  }
`;


import { IoMdClipboard } from "react-icons/io";

const YourOwnTab = ({ data, showPay = false, onPay, refetchOwnExpenseClaims, openExpense }: any) => {

  const draftExpenses = data.filter((item: any) => item.status === "draft");
  const submittedExpenses = data.filter((item: any) => item.status === "submitted");
  const approvedExpenses = data.filter((item: any) => item.status === "approved");
  const paidExpenses = data.filter((item: any) => item.status === "paid");
  const rejectedExpenses = data.filter((item: any) => item.status === "rejected");

  const totalSubmittedAmount = submittedExpenses.reduce((acc: number, item: any) => acc + (item.purchase_amount || 0), 0);
  const totalApprovedAmount = approvedExpenses.reduce((acc: number, item: any) => acc + (item.purchase_amount || 0), 0);
  const totalPaidAmount = paidExpenses.reduce((acc: number, item: any) => acc + (item.purchase_amount || 0), 0);

  const renderExpenseSection = (expenses: any[], title: string, count: number) => (
    <div style={{ marginBottom: "2rem" }}>
      <Subtitle style={{ marginBottom: "1rem" }}>
        {title} <span>({count})</span>
      </Subtitle>
      {expenses.length > 0 ? (
        expenses.map((item: any, index: any) => (
          <ExpenseCard
            key={item?.id}
            data={item}
            bgColor={
              Utils.LIGHT_COLOR_CODES[index % Utils.LIGHT_COLOR_CODES.length]
            }
            refetchOwnExpenseClaims={refetchOwnExpenseClaims} 
            openExpense={openExpense}
          />
        ))
      ) : (
        <div style={{ 
          textAlign: "center", 
          // padding: "1rem 1rem", 
          color: "#666",
          fontSize: "0.9rem",
          // backgroundColor: "#f8f9fa",
          // borderRadius: "4px",
          // border: "1px dashed #ddd"
        }}>
          No {title.toLowerCase()} expenses 
        </div>
      )}
    </div>
  );

  console.log("YourOwnTab data", {
    totalSubmittedAmount,
    totalApprovedAmount,
  });

  return (
    <div style={{ maxWidth: "85%", margin: "auto" }}>
      <Header>
        <Title>
          {/* All <span>({data.length})</span> */}
          Your Own Expenses 
          {/* <span>({data.length})</span> */}
        </Title>
      </Header>

      <div style={{
        display: 'flex',
        backgroundColor: '#fff',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        marginBottom: '2rem',
        overflow: 'hidden',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          flex: 1,
          padding: '2rem',
          borderRight: '1px solid #e0e0e0',
          textAlign: 'center'
        }}>
          <div style={{
        fontSize: '1rem',
        color: '#666',
        fontWeight: '500'
          }}>
        Submitted Amount
          </div>
          <div style={{
        fontSize: '2rem',
        fontWeight: 'bold',
        // color: '#f39c12',
        color: '#28a745',
        marginBottom: '0.5rem'
          }}>
        {Utils.getCommanSepartedNumericStringWithDollar(totalSubmittedAmount)}
          </div>
          
        </div>
        <div style={{
          flex: 1,
          padding: '2rem',
          borderRight: '1px solid #e0e0e0',
          textAlign: 'center'
        }}>
          <div style={{
        fontSize: '1rem',
        color: '#666',
        fontWeight: '500'
          }}>
        To be paid
          </div>
          <div style={{
        fontSize: '2rem',
        fontWeight: 'bold',
        color: '#28a745',
        marginBottom: '0.5rem'
          }}>
        {Utils.getCommanSepartedNumericStringWithDollar(totalApprovedAmount)}
          </div>
          
        </div>
        <div style={{
          flex: 1,
          padding: '2rem',
          textAlign: 'center'
        }}>
          <div style={{
        fontSize: '1rem',
        color: '#666',
        fontWeight: '500'
          }}>
        Paid Amount
          </div>
          <div style={{
        fontSize: '2rem',
        fontWeight: 'bold',
        color: '#28a745',
        marginBottom: '0.5rem'
          }}>
        {Utils.getCommanSepartedNumericStringWithDollar(totalPaidAmount)}
          </div>
          
        </div>
      </div>

      <div>
        {data && data.length > 0 ? (
          <>
            {renderExpenseSection(draftExpenses, "Draft", draftExpenses.length)}
            {renderExpenseSection(submittedExpenses, "Submitted", submittedExpenses.length)}
            {renderExpenseSection(approvedExpenses, "Approved", approvedExpenses.length)}
            {renderExpenseSection(paidExpenses, "Paid", paidExpenses.length)}
            {renderExpenseSection(rejectedExpenses, "Rejected", rejectedExpenses.length)}
          </>
        ) : (
          <div style={{ 
            textAlign: "center", 
            padding: "3rem 2rem", 
            color: "#666",
            fontSize: "1.1rem",
            fontWeight: "500"
          }}>
            <div style={{ marginBottom: "0.5rem",  }}>
              <IoMdClipboard size={28} />
            </div>
            No expenses claims found
            <div style={{ 
              fontSize: "0.9rem", 
              color: "#999", 
              marginTop: "0.5rem" 
            }}>
              Start by submitting a new expense claim.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default YourOwnTab;
